import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useMutation } from '@tanstack/react-query';
import { modifyURLStates } from '../../../../shared/utils/utils-routing';
import { invalidateLibraryManagedProductGroupFeaturedPages } from './useLibraryManagedProductGroupsFeaturePages';
import { globalErrorResponse, showNotification } from '../../../../store/notifications/actions';
import { saveLibraryManagedProductGroupSortBy } from './apiSaveLibraryManagedProductGroupSortBy';
import { useTranslation } from 'react-i18next';
import { getPaginationStateObject } from '../../../../shared/common/Pagination';
import { browserClient } from '../../../../react-query';

interface VariablesObject {
    sorting: string;
    productGroupId: string;
    title: string;
}

const LIBRARY_MANAGED_PRODUCT_GROUP_SORT_BY_KEY = 'libraryManagedProductGroupSortByKey';

export const useSaveLibraryManagedProductGroupSortBy = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();

    return useMutation(saveLibraryManagedProductGroupSortBy as any, {
        onSuccess: async (data, variables: VariablesObject) => {
            const pageQueryState = getPaginationStateObject();
            const sortByQueryState = {
                name: 'sortBy',
                value: variables.sorting === 'custom' ? 'custom' : 'releaseDateNewToOld',
                encode: false
            };
            const search = modifyURLStates(history.location.search, [pageQueryState, sortByQueryState]);
            history.replace({ pathname: history.location.pathname, search });

            invalidateLibraryManagedProductGroupSortByKey().then();
            invalidateLibraryManagedProductGroupFeaturedPages().then();

            dispatch(showNotification(t('marketing.productGroups.warnings.saveSortingOrderSuccessful')));
        },
        onError: () => {
            dispatch(globalErrorResponse(t('marketing.productGroups.warnings.saveSortingOrderError')));
        }
    });
};

export const invalidateLibraryManagedProductGroupSortByKey = () => {
    return browserClient.invalidateQueries([LIBRARY_MANAGED_PRODUCT_GROUP_SORT_BY_KEY]);
};
